module.exports = require('./helpers/bundle-url').getBundleURL('dZee7') + "logo-dark.eefe0b7f.svg";